import { render, staticRenderFns } from "./DescargarAndreani.vue?vue&type=template&id=081ca231&"
import script from "./DescargarAndreani.vue?vue&type=script&lang=js&"
export * from "./DescargarAndreani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports